/**
 * Section landing routes for the three primary work areas in the companion
 * shell. Their visible home pages belong to VerificationShell so they remain
 * mounted while a selected feature opens in the pane to their right.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";

export const contextSectionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/context",
  component: () => null,
});

export const changesSectionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/changes",
  component: () => null,
});
